;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { BaseButton } from '@qogita/ui/v2/base-button'
import { Logo } from '@qogita/ui/v2/logo'
import Link from 'next/link'
import { Fragment } from 'react'
import { routes } from 'src/deprecated/utils/routes'

import { Sidebar } from './Sidebar'

type MobileSidebarProps = {
  open: boolean
  setOpen: (open: boolean) => void
}
export const MobileSidebar = ({ open, setOpen }: MobileSidebarProps) => {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-40 lg:hidden" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-600/90" />
        </Transition.Child>

        <div className="fixed inset-0 z-40 flex">
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <Dialog.Panel className="relative flex w-full max-w-[80%] flex-1 flex-col bg-white pt-7 sm:max-w-xs">
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute top-0 right-0 -mr-12 pt-2">
                  <BaseButton
                    // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
                    className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:ring-2 focus:outline-hidden focus:ring-inset"
                    onClick={() => setOpen(false)}
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XMarkIcon
                      className="h-7 w-7 text-white"
                      aria-hidden="true"
                    />
                  </BaseButton>
                </div>
              </Transition.Child>

              <div className="flex h-[60px] shrink-0 items-center self-end px-4">
                <Link
                  href={routes.dashboard}
                  className="rounded-sm focus:ring-2 focus:ring-offset-2 focus:outline-hidden"
                >
                  <Logo
                    name="qogitaSellersV2"
                    className="h-[3.0625rem] w-[7.875rem]"
                  />
                </Link>
              </div>
              <Sidebar onClickRoute={() => setOpen(false)} />
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
